// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.ta .singleLineRockwellHeader {
    font-size: 26px;
    margin-top: 10px;
}
*/
.ta .singleLineRockwellHeader {
  color: black;
  font-size: 26px;
  font-family: 'Rockwell';
  margin: 30px 0px 30px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/premiumAdmin/header.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB","sourcesContent":["/*.ta .singleLineRockwellHeader {\n    font-size: 26px;\n    margin-top: 10px;\n}\n*/\n.ta .singleLineRockwellHeader {\n  color: black;\n  font-size: 26px;\n  font-family: 'Rockwell';\n  margin: 30px 0px 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
